import React from 'react'

const _window = typeof window !== 'undefined' ? window : null

export type CloseDropdownProps = {
  closedBy?: 'click outside' | 'trigger' | 'esc' | 'blur'
  e?: MouseEvent | KeyboardEvent | Event
}

export type UseDropdownEventsProps = {
  triggerRef: React.RefObject<HTMLDivElement>
  dropdownListRef: React.RefObject<HTMLDivElement>
  onClose: (args: CloseDropdownProps) => void
  itemClickToClose: boolean
}

export default function useDropdownEvents({
  triggerRef,
  dropdownListRef,
  onClose,
  itemClickToClose,
}: UseDropdownEventsProps) {
  React.useEffect(() => {
    const handleBodyClick = (e: MouseEvent) => {
      if (
        !triggerRef.current?.contains(e.target as Node) &&
        (!dropdownListRef.current?.contains(e.target as Node) ||
          itemClickToClose === true)
      ) {
        onClose({ closedBy: 'click outside', e })
      }
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose({ closedBy: 'esc', e })
        e.stopPropagation()
      }
    }

    const handleDropdownBlur = (e: Event) => {
      if (!dropdownListRef.current?.contains(e.target as Node)) {
        onClose({ closedBy: 'blur', e })
      }
    }

    _window?.document.body.addEventListener('keydown', handleKeyDown)
    _window?.document.body.addEventListener('click', handleBodyClick)
    dropdownListRef.current?.addEventListener('blur', handleDropdownBlur)

    return () => {
      _window?.document.body.removeEventListener('keydown', handleKeyDown)
      _window?.document.body.removeEventListener('click', handleBodyClick)
      dropdownListRef.current?.removeEventListener('blur', handleDropdownBlur)
    }
  }, [])

  return null
}
